export const url = {
  auth: {
    signin: '/apirest/v1/auth/signin',
    refresh: '/apirest/v1/auth/refresh',
    switch: '/apirest/v1/auth/switch',
    reset: '/apirest/v1/auth/resetpassword',
    oidc: '/apirest/v1/auth/oidc',
    okta: '/apirest/v1/auth/okta',
    totp: '/apirest/v1/auth/totp',
    saveConfigColumn: '/apirest/v1/columnsettings',
    get_valid_token: '/apirest/v1/auth/resetpassword',
    send_error_info: '/apirest/v1/logcrash',
    check_me: '/apirest/v1/user/check/me',
  },
  user: {
    menu: '/apirest/v1/user/menu',
    profile: '/apirest/v1/user/my_account',
    update_pwd: '/apirest/v1/user/changepassword',
    get_otp: '/apirest/v1/user/my_account/totp/enable',
    disable_totp: '/apirest/v1/user/my_account/totp/disable',
  },
  notification: {
    clear_all: '/apirest/v1/notification/clearall',
  },
  gpi_tracker: {
    tracking: '/apirest/v1/tracking/',
  },
  dashboard: {
    dashboard_liste: '/apirest/v1/dashboardsettings/dashboard/search',
    get_widget: '/apirest/v1/dashboardsettings/dashboard/',
    updateWidget: '/apirest/v1/dashboardsettings/dashboard/',
    add_widget: '/apirest/v1/dashboardsettings/dashboard',
    delete_dashboard: '/apirest/v1/dashboardsettings/dashboard/',
    get_data_dashboard: '/apirest/v1/dashboardsettings/dashboard/',
    print_treasury: '/apirest/v1/dashboard/treasury/print',
    get_unitaire: '/apirest/v1/dashboardsettings/dashboard/',
    get_treasure_balance: '/apirest/v1/dashboard/treasury/transactionbalance',
    get_group_position: '/apirest/v1/dashboard/treasury/groupposition',
  },
  group_widget: {
    baseURL: '/apirest/v1/dashboardsettings/widgetgroup/',
    search: '/apirest/v1/dashboardsettings/widgetgroup/search',
    getFilters: '/apirest/v1/dashboardsettings/widgetgroup/search/filters',
    add_widget: '/apirest/v1/dashboardsettings/widgetgroup',
  },
  cash: {
    flux: {
      batch: {
        baseURL: '/apirest/v1/cash/flow/batch',
        editMass: '/apirest/v1/cash/flow/batch/remittance/massedit/get',
        putRemittance: '/apirest/v1/cash/flow/batch/remittance/massedit/valid',
      },
      batchmanagement: {
        baseURL: '/apirest/v1/cash/flow/batchmanagement',
        search: '/apirest/v1/cash/flow/batchmanagement/pending/search',
        pending: '/apirest/v1/cash/flow/batchmanagement/pending/',
        refresh: '/apirest/v1/cash/flow/batchmanagement/pending/',

        delete: 'apirest/v1/cash/flow/batchmanagement/pending/{pnIDLot}/delete',
        delete_comment: '/apirest/v1/cash/flow/batchmanagement/comment/',
      },
      batch_history: {
        filter: '/apirest/v1/cash/flow/batchhistory/search/filters',
        search: '/apirest/v1/cash/flow/batchhistory/search',
        advanced_filter:
          '/apirest/v1/cash/flow/batchhistory/advanced_search/filters',
        advanced_search: '/apirest/v1/cash/flow/batchhistory/advanced_search',
        baseURL: '/apirest/v1/cash/flow/batchhistory',
        sendEmail: '/apirest/v1/cash/flow/batch/',
      },
      integration: {
        filter: '/apirest/v1/cash/flow/integration/filters ',
        importFile: '/apirest/v1/cash/flow/integration/import',
      },
      signature: {
        search: '/apirest/v1/cash/flow/mysignaturepad/search',
        reject: '/apirest/v1/cash/flow/mysignaturepad/decline',
        sign: '/apirest/v1/cash/flow/mysignaturepad/sign',
        unlock: '/apirest/v1/cash/flow/mysignaturepad/unlock',
        signOTP: '/apirest/v1/cash/flow/mysignaturepad/sign/otpmode',
        signEbics: '/apirest/v1/cash/flow/mysignaturepad/sign/ebicsmode',
        signChallenge:
          '/apirest/v1/administration/communication/connector/signchallenge',
      },
      fraud_monitor: {
        baseURL: '/apirest/v1/cash/flow/fraudmonitor',
        search: '/apirest/v1/cash/flow/fraudmonitor/search',
      },
      cheque: {
        baseURL: '/apirest/v1/cash/flow/cheque',
        filter: '/apirest/v1/cash/flow/cheque/search/filters',
        search: '/apirest/v1/cash/flow/cheque/search',
      },
      saisie: {
        baseURL: '/apirest/v1/cash/flow/entry',
        search: '/apirest/v1/cash/flow/entry/search',
        getFilters: '/apirest/v1/cash/flow/entry/search/filters',
      },
      analyse: {
        getFilters: '/apirest/v1/cash/flow/analysis/search/filters',
        search: '/apirest/v1/cash/flow/analysis/search',
      },
    },
    releves: {
      search: '/apirest/v1/cash/statement/account/search',
      search_avancee:
        '/apirest/v1/cash/statement/account/advancedsearch/filters',
      search_avancee_list:
        '/apirest/v1/cash/statement/account/advancedsearch/search',
      get_account_detail: '/apirest/v1/cash/statement/account/details/',
      export: '/apirest/v1/cash/statement/account/export',
      import: '/apirest/v1/administration/repository/accountstatement/import', // '/apirest/v1/cash/statement/account/import',
      get_account_transaction:
        '/apirest/v1/cash/statement/account/transaction/',
      get_electro_relever:
        '/apirest/v1/cash/statement/account/electronic/search/',
      print: '/apirest/v1/cash/statement/account/details/print/',
      generation_ecriture:
        '/apirest/v1/cash/statement/account/generateentries/',
      get_document: '/apirest/v1/repository/document/',
      get_charge_bancaire: '/apirest/v1/repository/bankfees/',
      get_filter_charge_bancaire:
        '/apirest/v1/repository/bankfees/search/filters',
      getAnalyse: '/apirest/v1/cash/statement/analysis',
      getAnalysePlacement: '/apirest/v1/treasury/placement/analysis',
      alert_releve_account: '/apirest/v1/cash/statement/alert/search',
      filter_alert_releve_account:
        '/apirest/v1/cash/statement/alert/search/filters',
    },
    parametrage: {
      subsid_users: {
        baseURL: '/apirest/v1/cash/settings/user',
        search: '/apirest/v1/cash/settings/user/search',
      },
      group_users: {
        baseURL: '/apirest/v1/cash/settings/usergroup',
        search: '/apirest/v1/cash/settings/usergroup/search',
        getFilters: '/apirest/v1/cash/settings/usergroup/search/filters',
        synthesis: '/apirest/v1/cash/settings/usergroup/print/synthesis',
        export_droit: '/apirest/v1/cash/synthesis/user',
      },
      four_eyes: {
        baseURL: '/apirest/v1/cash/settings/4eyes/',
        search: '/apirest/v1/cash/settings/4eyes/search',
        validation: '/apirest/v1/validator_4eyes',
      },
      smart_tags: '/apirest/v1/cash/settings/smarttagsubscription/search',
      smart_tags_by_id: '/apirest/v1/cash/settings/smarttagsubscription/',
      create_smart_tags: '/apirest/v1/cash/settings/smarttagsubscription',
      college: {
        baseURL: '/apirest/v1/cash/settings/college',
        search: '/apirest/v1/cash/settings/college/search',
      },
      authority: {
        baseURL: '/apirest/v1/cash/settings/signingauthority',
        search: '/apirest/v1/cash/settings/signingauthority/search',
        get_filter_edit_create: '/apirest/v1/cash/settings/signingauthority/',
        update: '/apirest/v1/cash/settings/signingauthority/',
        post_authority_bank:
          '/apirest/v1/cash/settings/signingauthority/banking',
        put_authority_bank:
          '/apirest/v1/cash/settings/signingauthority/banking/',
      },
    },
    agios: {
      list: '/apirest/v1/cash/statement/agios/search',
      calcul: '/apirest/v1/cash/statement/agios/calculation',
      print: '/apirest/v1/cash/statement/agios/calculation/print',
    },
    backFIle: {
      list: '/apirest/v1/cash/statement/returnfile/search',
      getById: '/apirest/v1/cash/statement/returnfile/',
      export: '/apirest/v1/cash/statement/returnfile/',
    },
    mobilityBAnk: {
      liste: '/apirest/v1/cash/statement/bankingmobility/search',
      details: '/apirest/v1/cash/statement/bankingmobility/',
      print: '/apirest/v1/cash/statement/bankingmobility/search/print',
      printDetails: '/apirest/v1/cash/statement/bankingmobility/',
      update: '/apirest/v1/cash/statement/bankingmobility/update',
      update_tiers:
        '/apirest/v1/cash/statement/bankingmobility/thirdparty/update',
    },

    referentiel: {
      perimetre: {
        baseUrl: '/apirest/v1/entityscope',
      },
      document: {
        baseURL: '/apirest/v1/repository/document',
      },
      open_bic: {
        baseURL: '/apirest/v1/repository/checkbank',
      },
      company: {
        create_company: '/apirest/v1/cash/repository/company',
        baseURL: '/apirest/v1/cash/repository/company',
        scopeURL: '/apirest/v1/cash/repository/company?entity_id=',
        search: '/apirest/v1/cash/repository/company/search',
      },
      account: {
        baseURL: '/apirest/v1/cash/repository/account',
        search: '/apirest/v1/cash/repository/account/search',
        rib: '/apirest/v1/cash/repository/account/rib/',
        postAccountEtablish:
          '/apirest/v1/treasury/administration/establishment/account',
        get_agent: '/apirest/v1/cash/repository/account/contact/',
      },
      third_party_group: {
        baseURL: '/apirest/v1/cash/repository/thirdpartygroup',
        creation: '/apirest/v1/cash/repository/thirdpartygroup',
        search: '/apirest/v1/cash/repository/thirdpartygroup/search',
      },
      third_party: {
        baseURL: '/apirest/v1/cash/repository/thirdparty',
        search: '/apirest/v1/cash/repository/thirdparty/search',
        search_third_company:
          '/apirest/v1/cash/flow/entry/remittancedetails/search',
        checkIban: '/apirest/v1/repository/checkbank',
        putCallBack: '/apirest/v1/cash/repository/thirdparty/counter/appeal/',
      },
      scope: {
        baseURL: '/apirest/v1/cash/repository/scope',
        search: '/apirest/v1/cash/repository/scope/search',
        // getFilters: '/apirest/v1/cash/repository/scope/search/filters',
      },
      timeline: {
        baseURL: '/apirest/v1/cash/repository/timeline',
        search: '/apirest/v1/cash/repository/timeline/search',
      },
      mandate: {
        baseURL: '/apirest/v1/cash/repository/mandate',
        search: '/apirest/v1/cash/repository/mandate/search',
      },
    },
    comptabilite: {
      rules: {
        search: '/apirest/v1/cash/accountingreconciliation/rule/search',
        baseURL: '/apirest/v1/cash/accountingreconciliation/rule',
      },
      writing: {
        search: '/apirest/v1/cash/accountingreconciliation/entry/search',
        create: '/apirest/v1/cash/accountingreconciliation/entry',
        update: '/apirest/v1/cash/accountingreconciliation/entry/',
        reconciliation_by_id:
          '/apirest/v1/cash/accountingreconciliation/entry/',
        edit_masse:
          '/apirest/v1/cash/accountingreconciliation/entry/mass_edition/edit',
        print: '/apirest/v1/cash/accountingreconciliation/entry/print',
        import_file: '/apirest/v1/cash/accountingreconciliation/entry/import',
        visu_session:
          '/apirest/v1/cash/accountingreconciliation/entry/session/search',
        delete_session:
          '/apirest/v1/cash/accountingreconciliation/entry/session/',
      },
      rapprochement: {
        get_filter:
          '/apirest/v1/cash/accountingreconciliation/reconciliation/search/filters',
        search:
          '/apirest/v1/cash/accountingreconciliation/reconciliation/search',
        reconciliation1_1:
          '/apirest/v1/cash/accountingreconciliation/reconciliation/reconcil_1_1',
        reconciliationn_n:
          '/apirest/v1/cash/accountingreconciliation/reconciliation/reconcil_n_n',
        reconciliation_with_regle:
          '/apirest/v1/cash/accountingreconciliation/reconciliation/reconcil_by_rules',
        reconciliation:
          '/apirest/v1/cash/accountingreconciliation/reconciliation/reconcil',
        get_commment:
          '/apirest/v1/cash/accountingreconciliation/reconciliation/comment/search',
        comment:
          '/apirest/v1/cash/accountingreconciliation/reconciliation/comment',
        delete_comment:
          '/apirest/v1/cash/accountingreconciliation/reconciliation/comment/delete/',

        eclated:
          '/apirest/v1/cash/accountingreconciliation/reconciliation/accounting_entries/split/',
        valid_rappro:
          '/apirest/v1/cash/accountingreconciliation/reconciliation/reconcil/validation',
      },
      historique: {
        get_filter:
          '/apirest/v1/cash/accountingreconciliation/history/search/filters',
        search: '/apirest/v1/cash/accountingreconciliation/history/search',
        lister_session:
          '/apirest/v1/cash/accountingreconciliation/session_list/search',
        show_detail:
          '/apirest/v1/cash/accountingreconciliation/history/detail/search',
        dereconciliation:
          '/apirest/v1/cash/accountingreconciliation/history/dereconciliation',
      },
      consultation: {
        getFilter:
          '/apirest/v1/cash/accountingreconciliation/consultation/search/filters',
        search: '/apirest/v1/cash/accountingreconciliation/consultation/search',
        print: '/apirest/v1/cash/accountingreconciliation/consultation/print',
        history:
          '/apirest/v1/cash/accountingreconciliation/consultation/history/search',
        downloadPdf:
          '/apirest/v1/cash/accountingreconciliation/consultation/history/print',
        init: {
          baseURL: '/apirest/v1/cash/accountingreconciliation/initialization',
          search:
            '/apirest/v1/cash/accountingreconciliation/consultation/movementnotreconciled/search',
          filters:
            '/apirest/v1/cash/accountingreconciliation/initialization/search/filters',
        },
      },
      closing: {
        get_filter:
          '/apirest/v1/cash/accountingreconciliation/closing/search/filters',
        search: '/apirest/v1/cash/accountingreconciliation/closing/search',
        print: '/apirest/v1/cash/accountingreconciliation/closing/print',
        histo: '/apirest/v1/cash/accountingreconciliation/closing/search',
        cloture: '/apirest/v1/cash/accountingreconciliation/closing/historic/',
        clotured_account:
          '/apirest/v1/cash/accountingreconciliation/closing/valid',
        dowload_doc:
          '/apirest/v1/cash/accountingreconciliation/closing/historic/',
        unlock_account:
          '/apirest/v1/cash/accountingreconciliation/closing/canceled',
        export_detail:
          '/apirest/v1/cash/accountingreconciliation/closing/export',
      },
      movement: {
        search: '/apirest/v1/cash/accountingreconciliation/unmatchedmvt/search',
      },
    },
    traitement: {
      job: {
        baseURL: '/apirest/v1/cash/treatment/job/',
        search: '/apirest/v1/cash/treatment/job/search',
        getRestart: '/apirest/v1/cash/treatment/job/restart/',
      },
      controle: {
        search: '/apirest/v1/cash/repository/thirdparty/sisid/request/search',
        create: '/apirest/v1/cash/repository/thirdparty/sisid/request',
        searchThirdParty:
          '/apirest/v1/cash/repository/thirdparty/sisid/request/search/filters/thirdparty',
        detailList: '/apirest/v1/cash/repository/thirdparty/sisid/request/',
      },
    },
    export_comptabilite: {
      rules: {
        search: '/apirest/v1/cash/accountingexport/rule/search',
        baseURL: '/apirest/v1/cash/accountingexport/rule',
      },
      interfaces: {
        search: 'apirest/v1/cash/accountingexport/interface/search',
        baseURL: '/apirest/v1/cash/accountingexport/interface',
        getFilter: '/apirest/v1/cash/accountingexport/interface/search/filters',
      },
      brouillards: {
        search: 'apirest/v1/cash/accountingexport/fog/search',
        baseURL: '/apirest/v1/cash/accountingexport/fog',
        getFilter: '/apirest/v1/cash/accountingexport/fog/search/filters',
        delete: '/apirest/v1/cash/accountingexport/fog/delete',
        visualisation: {
          search: '/apirest/v1/cash/accountingexport/fog/visualization/search',
          valid: '/apirest/v1/cash/accountingexport/fog/visualization/valid',
          file: '/apirest/v1/cash/accountingexport/fog/visualization/file',
        },
        session: '/apirest/v1/cash/accountingexport/fog/session/search',
        post_masse: '/apirest/v1/cash/accountingexport/fog/masseditition',
        get_custom_field: '/apirest/v1/cash/accountingexport/fog/',
      },
    },
    currenciesAndrates: {
      rates: {
        search: '/apirest/v1/cash/rate/search',
        changeFavorite: '/apirest/v1/cash/rate/changefavorite/',
        baseURL: '/apirest/v1/cash/rate/get/',
      },
      currency: {
        search: '/apirest/v1/cash/currency/search',
        changeFavorite: '/apirest/v1/cash/currency/changefavorite/',
        baseURL: '/apirest/v1/cash/currency/get/',
        new: '/apirest/v1/cash/currency/new',
      },
    },
  },

  treasury: {
    rate_values: {
      search: '/apirest/v1/treasury/settings/personalizedreferencerate/search',
      baseURL: '/apirest/v1/treasury/settings/personalizedreferencerate',
      getRateValue:
        '/apirest/v1/treasury/settings/personalizedreferencerate/get/',
      get_reference_rate:
        '/apirest/v1/treasury/settings/personalizedreferencerate/rate/update',
      validUpdate_reference_rate:
        '/apirest/v1/treasury/settings/personalizedreferencerate/rate/update',
    },
    personalized_rate: {
      baseURL: '/apirest/v1/treasury/settings/personalizedrate',
      search: '/apirest/v1/treasury/settings/personalizedrate/search',
      getRate: 'apirest/v1/treasury/settings/personalizedrate/',
      putRate: '/apirest/v1/treasury/settings/personalizedrate/rate/',
      verifyPersonalized: '/apirest/v1/treasury/settings/personalizedrate/',
    },
    rate_values_details: {
      search: '/apirest/v1/treasury/settings/ratevalueobject/id/search',
      baseURL: '/apirest/v1/treasury/settings/ratevalue/',
      getRateValue: '/apirest/v1/treasury/settings/ratevalue/get/',
      searchRateValueObject:
        '/apirest/v1/treasury/settings/ratevalueobject/search',
      baseURLObject: '/apirest/v1/treasury/settings/ratevalueobject/',
      getRateValueObject: '/apirest/v1/treasury/settings/ratevalueobject/get/',
      deleteRateValue: '/apirest/v1/treasury/settings/ratevalueobject/',
    },
    debt: {
      creditLine: {
        baseURL: '/apirest/v1/treasury/creditline',
        search: '/apirest/v1/treasury/creditline/search',
        filters: '/apirest/v1/treasury/creditline/search/filters',
      },
      analyse: '/apirest/v1/treasury/placement/debt',
    },
    emprunt: {
      baseURL: '/apirest/v1/treasury/loan',
      search: '/apirest/v1/treasury/loan/search',
      getById: '/apirest/v1/treasury/loan',
      create: '/apirest/v1/treasury/loan',
      update: '/apirest/v1/treasury/loan',
    },
    placement_consultation: '/apirest/v1/treasury/placement/consultation',
    compteTitre: {
      search: '/apirest/v1/treasury/placement/accounttitle/search',
      create: '/apirest/v1/treasury/placement/accounttitle',
      baseUrl: '/apirest/v1/treasury/placement/accounttitle',
    },
    compteTerme: {
      search: '/apirest/v1/treasury/placementcat/search',
      baseUrl: '/apirest/v1/treasury/placementcat',
      vizualize: '/apirest/v1/treasury/placement/accounttitle/',
      icne_cat: '/apirest/v1/treasury/placementcat/payment/icne',
    },
    payement: {
      search: '/apirest/v1/treasury/creditline/payment/search',
      payement: '/apirest/v1/treasury/creditline/payment',
      icne: '/apirest/v1/treasury/creditline/payment/icne',
    },
    cashpool: {
      baseURL: '/apirest/v1/treasury/cashpool',
      search: '/apirest/v1/treasury/cashpool/search',
    },
    settings: {
      natural_code: {
        baseURL: '/apirest/v1/treasury/administration/natural/code',
        search: '/apirest/v1/treasury/administration/natural/code/search',
        getGroupeCodeNature:
          '/apirest/v1/treasury/administration/natural/code/group/natural/search',
      },
      group_code_nature: {
        baseURL:
          '/apirest/v1/treasury/administration/natural/code/group/natural',
      },
      account_group: {
        baseURL: '/apirest/v1/treasury/accountgroup',
        search: '/apirest/v1/treasury/accountgroup/search',
      },
      report: {
        baseURL: '/apirest/v1/treasury/settings/reports',
        search: '/apirest/v1/treasury/settings/reports/search',
      },
      rules_treasury: {
        baseURL: '/apirest/v1/treasury/settings/rule',
        search: '/apirest/v1/treasury/settings/rule/search',
        duplicate: '/apirest/v1/treasury/settings/rule/duplicate/',
      },
      etablish_externe_treasury: {
        baseURL: '/apirest/v1/treasury/administration/establishment/external',
        search:
          '/apirest/v1/treasury/administration/establishment/external/search',
      },
      etablish_account_treasury: {
        baseURL: '/apirest/v1/treasury/administration/establishment/account/',
        search:
          '/apirest/v1/treasury/administration/establishment/account/search',
      },
    },
    current_account: {
      list: {
        baseURL: '/apirest/v1/treasury/currentaccount',
        search: '/apirest/v1/treasury/currentaccount/search',
        getFilters: '/apirest/v1/treasury/currentaccount/search/filters',
        statement: '/apirest/v1/treasury/currentaccount/treasurylist',
        treasury: '/apirest/v1/treasury/currentaccount/treasury',
        import: '/apirest/v1/treasury/currentaccount/importrlvcc/',
        account: '/apirest/v1/treasury/currentaccount/company/account',
        history: '/apirest/v1/treasury/currentaccount/history',
        printHistory: '/apirest/v1/treasury/currentaccount/calcul/print/',
        deleteHistory: '/apirest/v1/treasury/currentaccount/calcul/history/',
        importrlvcc: '/apirest/v1/treasury/currentaccount/importrlvcc/file',
        validatePurge:
          '/apirest/v1/treasury/currentaccount/treasury/clear/statment/rlvcc',
      },
      calculation: {
        search: '/apirest/v1/treasury/currentaccount/calcul/search',
        getFilters: '/apirest/v1/treasury/currentaccount/calcul/search/filters',
        launch: '/apirest/v1/treasury/currentaccount/calcul/valid',
      },
    },
    daily_treasury: {
      forecast: {
        down_file_xcl: '/apirest/v1/treasury/daily/forecast/import/getfile',
        baseURL: '/apirest/v1/treasury/daily/forecast',
        search: '/apirest/v1/treasury/daily/forecast/search',
        temporarySearch: '/apirest/v1/treasury/daily/forecast/temporary/search',
        temporaryGenerate:
          '/apirest/v1/treasury/daily/forecast/temporary/generate',
        automatic: {
          baseURL: '/apirest/v1/treasury/daily/forecast/automatic',
          search: '/apirest/v1/treasury/daily/forecast/automatic/search',
          getFilters:
            '/apirest/v1/treasury/daily/forecast/automatic/search/filters',
        },
      },
      research: {
        baseURL: '/apirest/v1/treasury/treasurysearch',
        search: '/apirest/v1/treasury/treasurysearch/search',
        getFilters: '/apirest/v1/treasury/treasurysearch/search/filters',
      },
      historique: {
        baseURL: '/apirest/v1/treasury/historic/daily',
      },
      search: {
        baseURL: '/apirest/v1//treasury/treasurysearch',
        search: '/apirest/v1//treasury/treasurysearch/search',
        getFilters: '/apirest/v1//treasury/treasurysearch/search/filters',
      },
      ventilation_treasury: {
        baseURL: '/apirest/v1/treasury/ventilation/',
        getFilters: '/apirest/v1/treasury/ventilation/search/filters',
        getRules: '/apirest/v1/treasury/ventilation/rule/search',
        getRule: '/apirest/v1/treasury/ventilation/rules',
        getRuls: '/apirest/v1/treasury/ventilation/search/rules',
        listData: '/apirest/v1/treasury/ventilation/search',
        putVentilate: '/apirest/v1/treasury/ventilation/ventilate',
      },
      reconciliation: {
        baseURL: '/apirest/v1/treasury/reconciliation',
        search: '/apirest/v1/treasury/reconciliation/search',
        getFilters: '/apirest/v1/treasury/reconciliation/search/filters',
      },
      intraday: {
        get: '/apirest/v1/cash/statement/account/intraday/search',
        generateforecast:
          '/apirest/v1/cash/statement/account/intraday/generateforecast',
      },
    },
    reporting: {
      analyse: {
        search: '/apirest/v1/treasury/analysis/reporting/search',
        getFilters: '/apirest/v1/treasury/analysis/reporting/search/filters',
      },
      analyseSolde: {
        getFilters: '/apirest/v1/treasury/reporting/balanceanalysis/filters',
        search: '/apirest/v1/treasury/reporting/balanceanalysis',
      },
    },
    evenements: {
      list: {
        baseURL: '/apirest/v1/treasury/event/',
        search: '/apirest/v1/treasury/event/search',
        getFilter: '/apirest/v1/treasury/event/search/filters',
        imprime: 'apirest/v1/treasury/event/print',
        putAmount: '/apirest/v1/treasury/event/modificationamount/',
        resent_mail: '/apirest/v1/treasury/event/email',
      },
    },
    fiche_valeur: {
      getFilter: '/apirest/v1/treasury/daily/valuesheet/search/filters',
      search: '/apirest/v1/treasury/daily/valuesheet/search',
      details: '/apirest/v1/treasury/daily/valuesheet/details',
      print: '/apirest/v1/treasury/daily/valuesheet/print',
    },
    compteRemunerer: {
      liste: '/apirest/v1/treasury/placementlivret/search',
      create: '/apirest/v1/treasury/placementlivret',
      baseUrl: '/apirest/v1/treasury/placementlivret',
      add_visualisation: '/apirest/v1/treasury/placementlivret/',
    },
    compteCapital: {
      liste: '/apirest/v1/treasury/placementcapitalization/search',
      baseUrl: '/apirest/v1/treasury/placementcapitalization',
      add_visualisation: '/apirest/v1/treasury/placementcapitalization/',
    },
    budget: {
      list: {
        baseURL: '/apirest/v1/treasury/budget/scenario/',
        search: '/apirest/v1/treasury/budget/scenario/search',
        get_scenario: '/apirest/v1/treasury/budget/scenario',
        post_scenario: '/apirest/v1/treasury/budget/scenario',
        put_scenario: '/apirest/v1/treasury/budget/scenario/',
      },
      analyse: {
        get_select_list: '/apirest/v1/treasury/budget/analysis/search',
        showDetail: '/apirest/v1/treasury/budget/analysis/period/',
      },
    },
  },

  administation: {
    perimetre: {
      baseURL: '/apirest/v1/administration/repository/perimeter/',
      create_perimetre: '/apirest/v1/administration/repository/perimeter',
      search: '/apirest/v1/administration/repository/perimeter/search',
    },
    ebam: {
      getIbans: '/apirest/v1/administration/repository/ebamcode/search',
      getIbansById: '/apirest/v1/administration/repository/ebamcode/',
      deleteIbam: '/apirest/v1/administration/repository/ebamcode/',
      addIbam: '/apirest/v1/administration/repository/ebamcode',
    },
    ebam_power: {
      getIbanPower:
        '/apirest/v1/administration/repository/power/description/search',
      getIbansById: '/apirest/v1/administration/repository/power/description/',
      baseURL: '/apirest/v1/administration/repository/power/description/',
      addIbam: '/apirest/v1/administration/repository/power/description',
    },

    category: {
      baseURL: '/apirest/v1/administration/repository/category',
      search: '/apirest/v1/administration/repository/category/search',
    },

    filiale: {
      baseURL: '/apirest/v1/administration/repository/entity/',
      postFiliale: '/apirest/v1/administration/repository/entity',
      search: '/apirest/v1/administration/repository/entity/search',
    },

    setting: {
      search: '/apirest/v1/administration/repository/settings/search',
      foryeux: {
        search: '/apirest/v1/administration/repository/settings/4Yeux/search',
        baseURL: '/apirest/v1/administration/repository/settings/4Yeux/',
      },
      groupe: {
        baseURL: '/apirest/v1/administration/repository/settings/groupsettings',
      },
      mobile: {
        baseURL:
          '/apirest/v1/administration/repository/settings/mobilesettings',
        generateKey:
          '/apirest/v1/administration/repository/settings/mobilesettings/generatekey',
        put: '/apirest/v1/administration/repository/settings/mobilesettings/apikey/',
        post: '/apirest/v1/administration/repository/settings/mobilesettings/apikey',
      },
      securite: {
        baseURL:
          '/apirest/v1/administration/repository/settings/securitysettings',
        activate_transaction:
          '/apirest/v1/administration/repository/settings/securitysettings/sisidtransaction/activate',
      },
      signature: '/apirest/v1/administration/repository/settings/signature',
    },

    groupetresorerie: {
      baseURL: '/apirest/v1/administration/repository/treasurygroup/',
      postTresorerie: '/apirest/v1/administration/repository/treasurygroup',
      search: '/apirest/v1/administration/repository/treasurygroup/search',
    },
    user: {
      baseURL: '/apirest/v1/administration/repository/user/',
      search: '/apirest/v1/administration/repository/user/search',
      post_user: '/apirest/v1/administration/repository/user',
      block_user_device:
        '/apirest/v1/administration/repository/user/changedevicestate/',
      favorite_user_entity:
        '/apirest/v1/administration/repository/user/changefavoriteentity/',
      initialise_totp:
        '/apirest/v1/administration/repository/user/initialization/totp/',
      reinitialise_pwd: '/apirest/v1/administration/repository/user/',
    },
    groupadmins: {
      search: '/apirest/v1/administration/repository/admingroup/search',
      baseURL: '/apirest/v1/administration/repository/admingroup',
    },

    document_type: {
      baseURL: '/apirest/v1/administration/repository/documenttype',
      search: '/apirest/v1/administration/repository/documenttype/search',
    },
    comment_report: {
      baseURL: '/apirest/v1/administration/customisation/commentreport',
      search: '/apirest/v1/administration/customisation/commentreport/search',
    },

    bank_holiday: {
      baseURL: '/apirest/v1/administration/repository/holiday',
      search: '/apirest/v1/administration/repository/holiday/list/search',
    },
    quality: {
      baseURL: '/apirest/v1/administration/repository/quality/',
      search: '/apirest/v1/administration/repository/quality/search',
      post_quality: '/apirest/v1/administration/repository/quality',
    },

    labels: '/apirest/v1/administration/repository/label/search',
    label_by_id: '/apirest/v1/administration/repository/label/',
    labels_create: '/apirest/v1/administration/repository/label',
    banque: '/apirest/v1/administration/repository/bank/search',
    banque_url: '/apirest/v1/administration/repository/bank',
    communication: {
      post_traitement: {
        search: '/apirest/v1/administration/communication/posttreatment/search',
        baseURL: '/apirest/v1/administration/communication/posttreatment',
      },
      chiffrement: {
        search: '/apirest/v1/administration/communication/encryption/search',
        get_encryption: '/apirest/v1/administration/communication/encryption/',
        create_encryption:
          '/apirest/v1/administration/communication/encryption',
        delete_account: '/apirest/v1/administration/communication/encryption/',
      },
      fraud_monitor: {
        baseUrl: '/apirest/v1/administration/communication/fraudmonitor',
        search: '/apirest/v1/administration/communication/fraudmonitor/search',
      },
      connector: {
        baseURL: '/apirest/v1/administration/communication/connector',
        search: '/apirest/v1/administration/communication/connector/search',
        ebics: '/apirest/v1/userid/',
      },
    },
    account_statement: {
      baseURL: '/apirest/v1/administration/repository/accountstatement',
      search: '/apirest/v1/administration/repository/accountstatement/search',
      clickCheckBox: '/apirest/v1/administration/repository/accountstatement/',
      updateRow: '/apirest/v1/administration/repository/accountstatement/',
      initialize_balance:
        '/apirest/v1/administration/repository/accountstatement/',
      unknow_list:
        '/apirest/v1/administration/repository/accountstatement/unknown/search',
      add_blackList:
        '/apirest/v1/administration/repository/accountstatement/unknown/blacklisted/',
      deleted:
        '/apirest/v1/administration/repository/accountstatement/unknown/delete/',
      search_account:
        '/apirest/v1/administration/repository/accountstatement/unknown/accountsearch/',
    },
    rules_account_statement: {
      baseURL: '/apirest/v1/administration/repository/statementrule',
      search: '/apirest/v1/administration/repository/statementrule/search',
      getItem: '/apirest/v1/administration/repository/statementrule/',
      deleteItem: '/apirest/v1/administration/repository/statementrule/',
    },
    interfaces: {
      imports: {
        baseURL: '/apirest/v1/administration/interface/import',
        search: '/apirest/v1/administration/interface/import/search',
        detail: {
          baseURL:
            '/apirest/v1/administration/interface/import/{idInterfaceImport}/detail',
          search:
            '/apirest/v1/administration/interface/import/{idInterfaceImport}/detail/search',
        },
        export_file: '/apirest/v1/administration/interface/import/file/export/',
        verify:
          '/apirest/v1/administration/interface/import/file/import/verify',
        import: '/apirest/v1/administration/interface/import/file/import',
      },
      flux: {
        get_filter: '/apirest/v1/administration/interface/flow/search/filters',
        search: '/apirest/v1/administration/interface/flow/search',
        get_constant: '/apirest/v1/administration/interface/flow/',
        create_flow: '/apirest/v1/administration/interface/flow',
        delete_flux: '/apirest/v1/administration/interface/flow/',
        update_flow: '/apirest/v1/administration/interface/flow/',
        verify_file_flux:
          '/apirest/v1/administration/interface/flow/file/import ',
        send_file: '',
        export_file: '/apirest/v1/administration/interface/flow/file/export/',
      },
      exports: {
        baseURL: '/apirest/v1/administration/interface/export',
        search: '/apirest/v1/administration/interface/export/search',
        detail: {
          baseURL:
            '/apirest/v1/administration/interface/export/{idInterfaceExport}/detail',
          search:
            '/apirest/v1/administration/interface/export/{idInterfaceExport}/detail/search',
        },
        verify_file:
          '/apirest/v1/administration/interface/export/file/import/verify',
        import_file: '/apirest/v1/administration/interface/export/file/import',
        export_file: '/apirest/v1/administration/interface/export/file/export/',
      },

      formats: {
        baseURL: '/apirest/v1/administration/interface/format',
        search: '/apirest/v1/administration/interface/format/search',
        getFilters:
          '/apirest/v1/administration/interface/format/search/filters',
        detail: {
          baseURL:
            '/apirest/v1/administration/interface/format/{format_id}/details',
          search:
            '/apirest/v1/administration/interface/format/{format_id}/details/search',
          getFilters:
            '/apirest/v1/administration/interface/format/{format_id}/details/search/filters',
        },
        item: {
          baseURL:
            '/apirest/v1/administration/interface/format/{format_id}/details/{detail_format_id}/items',
          search:
            '/apirest/v1/administration/interface/format/{format_id}/details/{detail_format_id}/items/search',
          getFilters:
            '/apirest/v1/administration/interface/format/{format_id}/details/{detail_format_id}/items/search/filters',
        },
      },
      import_rule: {
        baseURL: '/apirest/v1/administration/interface/importrule',
        search: '/apirest/v1/administration/interface/importrule/search',
      },
      export_rule: {
        baseURL: '/apirest/v1/administration/interface/exportrule',
        search: '/apirest/v1/administration/interface/exportrule/search',
        getFilters:
          '/apirest/v1//administration/interface/exportrule/search/filters',
      },
    },

    customisation: {
      listes: {
        baseURL: '/apirest/v1/administration/customisation/list',
        search: '/apirest/v1/administration/customisation/list/search',
        detail: {
          baseURL:
            '/apirest/v1/administration/customisation/list/{list_id}/details',
          search:
            '/apirest/v1/administration/customisation/list/{list_id}/details/search',
        },
      },
      accounting_field: {
        baseURL: '/apirest/v1/administration/customisation/accountingfield',
        search:
          '/apirest/v1/administration/customisation/accountingfield/search',
      },

      dynamic_method: {
        baseURL: '/apirest/v1/administration/customisation/dynamicmethod',
        search: '/apirest/v1/administration/customisation/dynamicmethod/search',
        getFilters:
          '/apirest/v1/administration/customisation/dynamicmethod/search/filters',
        getRules:
          '/apirest/v1/administration/customisation/dynamicmethod/detail/interface',
      },

      email_template: {
        baseURL: '/apirest/v1/administration/customisation/emailtemplate',
        search: '/apirest/v1/administration/customisation/emailtemplate/search',
      },
      email_rule: {
        baseURL: '/apirest/v1/administration/customisation/emailrule',
        search: '/apirest/v1/administration/customisation/emailrule/search',
        getFilters: '/apirest/v1/administration/customisation/emailrule',
      },
      email_report_rule: {
        search:
          '/apirest/v1/administration/customisation/emailrule/report/search',
        baseUrl: '/apirest/v1/administration/customisation/emailrule/report',
        execute_imediat:
          '/apirest/v1/administration/customisation/emailrule/report/execution',
      },
      custom_field: {
        getDataSource:
          '/apirest/v1/administration/customisation/fieldmask/search',
        delete: '/apirest/v1/administration/customisation/fieldmask/',
        getData: '/apirest/v1/administration/customisation/fieldmask/',
        create_field: '/apirest/v1/administration/customisation/fieldmask',
        update: '/apirest/v1/administration/customisation/fieldmask/',
      },
    },
  },
  communication: {
    search: '/apirest/v1/administration/communication/exchangedfile/search',
    baseURL: '/apirest/v1/administration/communication/exchangedfile',
    download: '/apirest/v1/administration/communication/exchangedfile/download',
    visualisation:
      '/apirest/v1/administration/communication/exchangedfile/visualization/companion/',
  },
  customisation: {
    custom: '/apirest/v1/administration/customisation/thirdparty/search',
    delete_custom: '/apirest/v1/administration/customisation/thirdparty/',
    get_custom: '/apirest/v1/administration/customisation/thirdparty/',
    put_custom: '/apirest/v1/administration/customisation/thirdparty/',
    create_custom: '/apirest/v1/administration/customisation/thirdparty',
    correspondance_custom: '',
  },
  correspondance: {
    delete_correspondance:
      '/apirest/v1/administration/customisation/correspondence/',
    get_correspondance:
      '/apirest/v1/administration/customisation/correspondence/',
    put_correspondance:
      '/apirest/v1/administration/customisation/correspondence/',
    create_correspondance:
      '/apirest/v1/administration/customisation/correspondence',
    correspondance_custom:
      '/apirest/v1/administration/customisation/correspondence/search',
    import_file:
      '/apirest/v1/administration/customisation/correspondence/import',
    export_file:
      '/apirest/v1/administration/customisation/correspondence/export/',
  },
  detail_correspondance: {
    delete_detail_correspondance:
      '/apirest/v1/administration/customisation/correspondence/',
    get_detail_correspondance:
      '/apirest/v1/administration/customisation/correspondence/',
    put_detail_correspondance:
      '/apirest/v1/administration/customisation/correspondence/',
    create_detail_correspondance:
      '/apirest/v1/administration/customisation/correspondence/',
    correspondance_detail_custom:
      '/apirest/v1/administration/customisation/correspondence/',
  },

  smarttag: {
    getallsmart: '/apirest/v1/administration/repository/smartag/search',
    delete_smart: '/apirest/v1/administration/repository/smartag/',
    get_smart: '/apirest/v1/administration/repository/smartag/',
    put_smart: '/apirest/v1/administration/repository/smartag/',
    post_smart: '/apirest/v1/administration/repository/smartag',
  },
  auditconnexion: {
    getall_audit_connexion: '/apirest/v1/administration/audit/login/search',
  },
  audithistoryfile: {
    getallfileHistory:
      '/apirest/v1/administration/audit/integratedfiles/search',
    print: '/apirest/v1/administration/audit/integratedfiles/print',
  },
  auditTrustedThird: {
    getallList: '/apirest/v1/administration/audit/trustedthirdparty/search',
    getDetail: '/apirest/v1/administration/audit/trustedthirdparty/',
  },

  auditgdpr: {
    getall_audit_gdpr: '/apirest/v1/administration/audit/gdpr/search',
    anonym: '/apirest/v1/administration/audit/gdpr/anonymize',
  },
  auditService: {
    search_service_audit: '/apirest/v1/administration/audit/service/search',
    get_constant: '/apirest/v1/administration/audit/service/search/filters',
  },
  hashFile: {
    list: '/apirest/v1/administration/audit/hashfile/search',
    delete: '/apirest/v1/administration/audit/hashfile/',
  },
  histoApi: {
    list: '/apirest/v1/administration/audit/apicall/search',
  },
  document: {
    authority_document: {
      search_authority_document:
        '/apirest/v1/administration/repository/signingauthority/document/search',
      post_authority_document:
        '/apirest/v1/administration/repository/signingauthority/document',
      baseurl_authority_document:
        '/apirest/v1/administration/repository/signingauthority/document/',
    },
    generation_document: {
      get_list: '/apirest/v1/cash/document/bankingauthority/generation/search',
      put_generate:
        'apirest/v1/cash/document/bankingauthority/generation/valid',
    },
    generation_doc_pouvoir: {
      list: '/apirest/v1/cash/documentauthority/generation/search',
      put_generate: 'apirest/v1/cash/documentauthority/generation/valid',
    },
    validation_doc_pouvoir: {
      list: '/apirest/v1/cash/documentauthority/validation/search',
    },
    doct_societe_generation: {
      list: '/apirest/v1/cash/companydocument/generation/search',
      put_generate: 'apirest/v1/cash/companydocument/generation/valid',
    },
    doct_societe_validation: {
      list: '/apirest/v1/cash/companydocument/validation/search',
    },
    college_document: {
      get_list: '/apirest/v1/administration/repository/college/document/search',
      base_url: '/apirest/v1/administration/repository/college/document/',
      post_college_document:
        '/apirest/v1/administration/repository/college/document',
      get_college_document: '',
      put_college_document: '',
    },
    validation_document: {
      get_list: '/apirest/v1/cash/document/ebamvalidation/search',
      delete_validation: '/apirest/v1/cash/document/ebamvalidation/',
      getAudit: '/apirest/v1/cash/document/ebamvalidation/',
      printValidation: '/apirest/v1/cash/document/ebamvalidation/',
      putToSignature: '/apirest/v1/cash/document/ebamvalidation/signature',
      printSelectedValidation: '/apirest/v1/cash/document/ebamvalidation/print',
      printSelectedCarton:
        '/apirest/v1/cash/document/ebamvalidation/signatory/signaturecards/print',
      printSelectedIdentity:
        '/apirest/v1/cash/document/ebamvalidation/signatory/idcard/print',
      putDocument: '/apirest/v1/cash/document/ebamvalidation/signature/upload/',
      postAttribute:
        '/apirest/v1/cash/document/ebamvalidation/attribution/search',
      putAttribut: '/apirest/v1/cash/document/ebamvalidation/attribution/valid',
      printHistory: '/apirest/v1/repository/document/',
    },
    gestion_signataire: {
      list: '/apirest/v1/cash/bankingauthority/signatory/search',
      send_mail_bank: '/apirest/v1/cash/bankingauthority/signatory/sendmail',
      imprime: '/apirest/v1/cash/bankingauthority/signatory/print/',
    },
    mandant: {
      getListMandant: '/apirest/v1/cash/bankingauthority/principal/search',
      getItemMandant: '/apirest/v1/cash/bankingauthority/principal/',
      updateMandat: '/apirest/v1/cash/bankingauthority/principal/',
    },
  },
  value_gestion: {
    search_value_gestion: '/apirest/v1/treasury/placement/valuetitle/search',
    add_value_gestion: '/apirest/v1/treasury/placement/valuetitle',
    put_value_gestion: '/apirest/v1/treasury/placement/valuetitle/',
    get_list_visualise: '/apirest/v1/treasury/placement/valuetitle/',
    list_value_cours: '/apirest/v1/treasury/placement/valuetitle/rate/update',
  },
  signature_document: {
    sign: '/apirest/v1/cash/document/ebamvalidation/signature/document',
    electronic_sign: '/apirest/v1/cash/document/ebamvalidation/electronicsign',
  },
  history_document: {
    save_action: '/apirest/v1/cash/document/ebamvalidation/signature/action',
    delete: '/apirest/v1/cash/document/ebamvalidation/signature/action/',
    verify_doc:
      '/apirest/v1/cash/document/ebamvalidation/signature/verification/',
    get_email_details: '/apirest/v1/cash/document/ebamhistory/emaildetails',
    send_email: '/apirest/v1/cash/document/ebamhistory/sendbank',
  },
  risk: {
    list_operation: {
      getList: 'search',
      denouer: 'settle',
      compensationPayment: 'compensation_payment',
      baseurl: 'apirest/v1/risks/operations/change',
      // postData: '/apirest/v1/risks/operations/change',
      validDeal: '/apirest/v1/risks/operations/change/valid',
      // verify_deal: '/apirest/v1/risks/operations/change/deal/',
      audit: '/apirest/v1/risks/operations/change/audit/',
      imprime_deal: '/apirest/v1/risks/operations/change/contrat/',
    },
    list_cootation: {
      getList: '/apirest/v1/risks/contract/change/search',
      baseurl: '/apirest/v1/risks/contract/change/',
      postData: '/apirest/v1/risks/contract/change',
    },
    denoue: {
      getDenoue: 'apirest/v1/risks/operations/change/deal/',
      getFlowList: '/apirest/v1/risks/operations/change/deal/flow',
      validResolve: '/apirest/v1/risks/operations/change/deal/valid/',
      postDeal: '/apirest/v1/risks/operations/change/valid',
    },
  },
  calendar: {
    listEvent: '/apirest/v1/risks/operations/change/calendar/search',
  },
}

